// extracted by mini-css-extract-plugin
export var typingIndicator = "_qk-0";